import { render } from "./UserTrackingHistory.vue?vue&type=template&id=3858ed90&scoped=true"
import script from "./UserTrackingHistory.vue?vue&type=script&lang=ts"
export * from "./UserTrackingHistory.vue?vue&type=script&lang=ts"

import "./UserTrackingHistory.vue?vue&type=style&index=0&id=3858ed90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3858ed90"

export default script